import {Injectable} from '@angular/core';
import {SearchResultCareProviders} from '../../../types/SearchResultCareProviders';
import {DfpStateData} from '../../../types/DfpStateData';
import {RoutesEnums} from '../../../enums/RoutesEnums';
import {AdsStateService} from '../../../services/ads-state.service';
import {ToolsService} from '../../../services/tools.service';

@Injectable()
export class SearchConnectionsService {
  constructor(private adsStateService: AdsStateService, private tools: ToolsService) {}

  public updateAdsState(searchResults: SearchResultCareProviders): void {
    const dfpState: DfpStateData = this.adsStateService.getDefaultDfpState();
    if (!this.tools.isNil(searchResults.searchResultContent.caregiverUnitType)) {
      dfpState.careproviderUnitTypeId = searchResults.searchResultContent.caregiverUnitType.id;
    }
    if (!this.tools.isNil(searchResults.searchResultContent.careServiceType)) {
      dfpState.careServiceTypeId = searchResults.searchResultContent.careServiceType.id;
    }
    if (!this.tools.isNil(searchResults.searchResultContent.symptom)) {
      dfpState.symptomId = searchResults.searchResultContent.symptom.id;
    }
    if (!this.tools.isNil(searchResults.searchResultContent.place)) {
      dfpState.placeId = searchResults.searchResultContent.place.id;
    }
    dfpState.pageModule = RoutesEnums.SEARCH;
    this.adsStateService.updateAdsState(dfpState);
  }
}
